import React, { memo } from 'react';
import { Switch, useRouteMatch } from 'react-router';
import { PrivateRoute } from 'common/AuthRoute';
import { BusinessPartnerAdditionalDevicesPage } from 'pages/BusinessPartnerManagement/BusinessPartnerAdditionalDevicesManagement/BusinessPartnerAdditionalDevicesPage';

export const BusinessPartnerAdditionalDevicesManagement = memo(() => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <PrivateRoute
        exact
        path={path}
        component={BusinessPartnerAdditionalDevicesPage}
      />
    </Switch>
  );
});
